export default [
  "Fasting",
  "Non-Fasting",
  "Postprandial (After Meal)",
  "Random",
  "Morning Sample",
  "Evening Sample",
  "Refrigerated",
  "Frozen",
  "On Ice",
  "Light Protected",
  "Aseptic Collection",
  "Sterile Container",
  "Preserved in EDTA",
  "Preserved in Heparin",
  "Preserved in Citrate",
  "Preserved in Formalin",
  "Preserved in SAF (for stool)",
  "Transport Medium Used",
  "Immediate Processing Required",
  "Unpreserved / Fresh",
];
